export const breakpoints = {
  xs: "576px", // X-Small devices
  sm: "768px", // Small devices
  md: "992px", // medium devices
  lg: "1200px", // large devices
};
